import * as angular from 'angular';
import {IController} from "angular";

export class ServicesEditBulkRelationsDialogViewCtrl implements IController {
  editableServices: any[];
  unEditableServices: any[];
  editRelatedChecked: boolean;
  onEditableServicesToggled: Function;


}

angular.module('bringoz.admin.cancellation-reasons')
  .component('servicesEditBulkRelationsDialogView', {
    bindings: {
      editableServices: "<?",
      unEditableServices: "<?",
      editRelatedChecked: "<?",
      onEditableServicesToggled: "&"
    },
    template: require('./services-edit-bulk-relations-dialog-view.html').default,
    controller: ServicesEditBulkRelationsDialogViewCtrl
  });
